export default "__VITE_ASSET__BdJbrYr9__"